const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
